import React from 'react';

const NetworkError: React.FC = () => {
  return <div>Network Error</div>;
};

export default NetworkError;
